import Cookies from "js-cookie";
const BASEURL = process.env.VUE_APP_BASE_URL;
class Help {
  headerFile() {
    const token = Cookies.get("token") || null;
    const headers = {
      Authorization: `Bearer ${token}`,
      headers: { "content-type": "multipart/form-data" },
    };
    return headers;
  }
  // pluck = key => array => Array.from(new Set(array.map(obj => obj[key])));
  pluck(array, key) {
    return array.map((o) => o[key]);
  }
  getId(object) {
    if (object === null || object === undefined) return null;
    if (typeof object === "object") {
      return object.id;
    } else {
      return object;
    }
  }

  salePro({ cart }) {
    var items = [];
    cart.map((item, index) => {
      const data = {
        txn: item.txn,
        product_id: item.id,
        discount: item.discount,
        qty: item.qty,
      };
      // Only send variant_id for variant products
      if (item.variant_id) {
        data.variant_id = item.variant_id;
      }
      // Include custom_price for dynamic pricing products or price channels
      if (item.customPrice !== undefined && item.customPrice !== null) {
        data.custom_price = item.customPrice;
      } else if (item.price != null && item.qty > 0) {
        const uAmt = Number(item.unitAmount) || 1;
        const perUnit = Number(item.price) / (Number(item.qty) * uAmt);
        if (
          item.item &&
          Math.abs(perUnit - Number(item.item.price_sale || 0)) > 0.001
        ) {
          data.custom_price = perUnit;
        }
      }
      // Include unit_amount for pack and dynamic products (from frontend)
      const packAmount =
        item.unitAmount ??
        ((item.item?.size?.unit === "pack" ||
          item.item?.size?.unit === "dynamic") &&
        item.item?.size?.amount
          ? item.item.size.amount
          : null);
      if (packAmount != null) {
        data.unit_amount = packAmount;
      }
      items.push(data);
    });
    return items;
  }

  // clearForm
  async clearForm(form, self) {
    Object.keys(form).forEach((key, index) => {
      if (typeof form[key] === "string") {
        self.form[key] = "";
      } else if (typeof form[key] === null) {
        self.form[key] = null;
      } else if (typeof form[key] === "number") {
        self.form[key] = 0;
      } else if (typeof form[key] === "") {
        self.form[key] = "";
      } else if (typeof form[key] === "null") {
        self.form[key] = "";
      }
    });
  }

  product(img) {
    if (img) {
      return `${BASEURL}/uploads/${img}`;
    } else {
      return "/images/product.png";
    }
  }
  img(img) {
    if (img === null || img === undefined) return "/images/pos.png";
    if ((img != null && img.includes("http")) || img.includes("https")) {
      return img;
    } else if (img) {
      return `${BASEURL}/uploads/${img}`;
    }
  }

  moneyFormat(num) {
    const currency = localStorage.getItem("currency") || "LAK";
    // "LAK", "THB", "USD"
    const currencies = [
      {
        text: "LAK",
        symbol: "₭",
      },
      {
        text: "THB",
        symbol: "฿",
      },
      {
        text: "USD",
        symbol: "$",
      },
    ];
    const find = currencies.find((val) => val.text === currency);
    if (num != null && num != undefined && find != undefined) {
      var p = Number(num).toFixed(2).split(".");
      const amt = p[0]
        .split("")
        .reverse()
        .reduce(function (acc, num, i, orig) {
          return num == "-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
        }, "");
      // if currency is LAK then symbol must be the end
      if (currency === "LAK") {
        return `${amt}${find.symbol}`;
      }
      return `${find.symbol}${amt}`;
    }
  }
  // Format an amount with its own row-level currency (not the store's global currency),
  // e.g. priceWithCurrency(1210, { code: "LAK", symbol: "₭" }) => "1,210₭"
  priceWithCurrency(num, currency) {
    if (num === null || num === undefined || num === "") return "0";
    const value = typeof num === "string" ? parseFloat(num) : num;
    if (isNaN(value)) return "0";
    const amt =
      value % 1 === 0
        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const symbol = (currency && currency.symbol) || "₭";
    const code = (currency && currency.code) || "LAK";
    // if currency is LAK then symbol must be at the end, same as moneyFormat()
    return code === "LAK" ? `${amt}${symbol}` : `${symbol}${amt}`;
  }
  moneyFormatPrint(val) {
    // format number with commas and .00 format
    if (val === null || val === undefined) return "0.00";
    // if string convert to number
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    return val
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  async cartArray(cart) {
    let arr = [];
    cart.map((val, index) => {
      const data = {
        product_id: val.id,
        stock: val.item.stock,
        qty: val.qty,
      };
      arr.push(data);
    });
    // find the cart each product in txn is not null
    const val = cart.find((val, index) => val.txn != null);
    return {
      cart: arr,
      txn: val?.txn ?? null,
    };
  }

  async tableOrder(cart) {
    let arr = [];
    cart.map((val, index) => {
      const data = {
        product_id: val.id,
        quantity: val.qty,
      };
      // Include variant_id if this is a variant product
      if (val.variant_id) {
        data.variant_id = val.variant_id;
      }
      arr.push(data);
    });
    // find the cart each product in txn is not null
    const val = cart.find((val, index) => val.txn != null);
    return {
      arr,
      cart_id: val?.txn ?? null,
    };
  }

  async getDifferentMonth(prop, start_date, end_date) {
    var date1 = new Date(start_date);
    var date2 = new Date(end_date);
    const msg1 = prop.$t("start_date_should");
    const msg2 = prop.$t("end_date_should");
    const msg3 = prop.$t("start_date_and");
    // check val should be less than end_date if not throw error message "Start date should be less than end date"
    if (date1 > date2) {
      throw new Error(msg1);
    }
    // check val should be greater than startDate if not throw error message "End date should be greater than start date"
    if (date2 < date1) {
      throw new Error(msg2);
    }
    // startDate and endDate should be between 3 month
    if (this.diffMonths(date1, date2) > 3) {
      throw new Error(msg3);
    }
    // get the difference in months
    var diffMonths = (date2.getFullYear() - date1.getFullYear()) * 12;
    diffMonths -= date1.getMonth();
    diffMonths += date2.getMonth();
    return diffMonths <= 0 ? 0 : diffMonths;
  }

  diffMonths(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60 * 24 * 7 * 4;
    return Math.abs(Math.round(diff));
  }
  pointFormat(num) {
    if (num != null && num != undefined) {
      // if num 1000 then return 1,000
      const point = num.toLocaleString();
      return point;
    }
    return 0;
  }
  addValueKey(menus) {
    let data = [];
    let trueFound = false;
    if (!menus || menus.length === 0 || menus === null) return data;
    for (let index = 0; index < menus.length; index++) {
      let element = menus[index];

      // If an element with `value` true has been found, assign false
      // to all following elements. Otherwise, try to assign true.
      if (trueFound) {
        element = {
          ...element,
          value: false,
        };
      } else {
        element = {
          ...element,
          value: element.menu.length > 0,
        };

        if (element.value) {
          trueFound = true;
        }
      }

      data.push(element);
    }
    return data;
  }

  menuCheck(menus, selected) {
    let tempSelected = [...selected];
    menus.forEach((item) => {
      if (item.menu.length) {
        let isSubIdInSelected = item.menu.some((sub) =>
          tempSelected.includes(sub.id)
        );
        let isItemIdInSelected = tempSelected.includes(item.id);
        if (isSubIdInSelected && !isItemIdInSelected) {
          // add item.id to tempSelected if any sub.id is in selected
          tempSelected.push(item.id);
        } else if (!isSubIdInSelected && isItemIdInSelected) {
          // remove item.id from tempSelected if no sub.id is in selected
          tempSelected = tempSelected.filter((id) => id !== item.id);
        }
      } else if (tempSelected.includes(item.id)) {
        // add item.id to tempSelected if it is in selected and it has no submenus
        tempSelected.push(item.id);
      }
    });
    // remove duplicate ids with sort a-z
    tempSelected = [...new Set(tempSelected)].sort((a, b) => a - b);
    return tempSelected;
  }

  GenCode() {
    const text = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "";
    for (let i = 0; i < 12; i++) {
      code += text.charAt(Math.floor(Math.random() * text.length));
    }
    return code;
  }

  isObject(data) {
    // check if data is object then data.id else data
    if (typeof data === "object") {
      return data.id;
    } else {
      return data;
    }
  }

  async comparePrice(props, price_input, price) {
    const _cash_back = props.$t("cash_back");
    const _check_your_amount = props.$t("check_your_amount");
    const _full_payment = props.$t("full_payment");
    if (price_input >= price) {
      const format = this.NumberFormat(price_input - price);
      const msg =
        price_input - price === 0 ? _full_payment : `${_cash_back} ${format}`;
      return {
        status: true,
        total: this.NumberFormat(price),
        message: msg,
      };
    } else {
      const format = this.NumberFormat(price - price_input);
      return {
        status: false,
        total: this.NumberFormat(price),
        message: `${_check_your_amount} ${format}`,
      };
    }
  }

  NumberFormat(val) {
    // format number with commas and .00 format
    if (val === null || val === undefined) return "0.00";
    // if string convert to number
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    return val
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  NumberPad(val) {
    // check if value contains . then add .00 to the end of the value, else return the value formatted
    if (val === null || val === undefined) return "0.00";
    // if string convert to number
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    if (val.toString().includes(".")) {
      return val
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  async posSale(state, payload) {
    const { received, cart, total_discount, total_price, currency } = state;
    const {
      customer_id,
      typeDiscount,
      status,
      type,
      note,
      paidAmount,
      paymentDetails,
      redeem_stamp_reward,
    } = payload;

    // Use paidAmount from payload if provided, otherwise use received from state
    let intReceived =
      paidAmount !== undefined ? parseFloat(paidAmount) : parseFloat(received);

    // Calculate the base price and detect cart currency
    let baseTotalPrice = 0;
    let cartCurrency = { code: "LAK", exchange_rate: 1 }; // Default to LAK

    if (cart && cart.length) {
      // Get currency info from first cart item
      const firstItem = cart[0];
      if (firstItem.currency && firstItem.currency.code !== "LAK") {
        cartCurrency = {
          code: firstItem.currency.code,
          exchange_rate: firstItem.exchange_rate || 1,
        };
      }

      baseTotalPrice = cart
        .map((e) => Number(e.price) || 0)
        .reduce((a, b) => a + b, 0);
    }

    // Determine effective payment currency from paymentDetails or state.currency
    let paymentCurrency = currency;
    if (paymentDetails && paymentDetails.currency_id) {
      paymentCurrency = {
        id: paymentDetails.currency_id,
        code: paymentDetails.currency_code || (paymentDetails.currency_id === 1 ? "LAK" : currency?.code),
        store_exchange_rate: paymentDetails.exchange_rate,
      };
    }

    // Apply currency conversion based on cart currency vs selected payment currency
    let finalTotalPrice = baseTotalPrice;
    let finalReceived = intReceived;
    let exchangeRateToSend = null; // Exchange rate to send in API request

    // Case 1: Cart is in foreign currency, paying in LAK (e.g. THB cart -> paying LAK)
    if (cartCurrency.code !== "LAK" && (!paymentCurrency || paymentCurrency.code === "LAK")) {
      let cartExchangeRate = parseFloat(cartCurrency.exchange_rate);

      // Apply correct exchange rates for cart currency
      if (cartCurrency.code === "THB" && cartExchangeRate === 1) {
        cartExchangeRate = 690; // THB to LAK rate
      }
      if (cartCurrency.code === "USD" && cartExchangeRate === 1) {
        cartExchangeRate = 22000; // USD to LAK rate
      }

      exchangeRateToSend = cartExchangeRate;
      if (cartExchangeRate > 0) {
        finalTotalPrice = baseTotalPrice * cartExchangeRate;
        finalReceived = intReceived;
      }
    }
    // Case 2: Cart is in LAK, paying in foreign currency (LAK -> THB/USD)
    else if (
      cartCurrency.code === "LAK" &&
      paymentCurrency &&
      paymentCurrency.code !== "LAK"
    ) {
      const exchangeRate = parseFloat(paymentCurrency.store_exchange_rate);
      exchangeRateToSend = exchangeRate;

      if (exchangeRate > 0) {
        finalTotalPrice = baseTotalPrice / exchangeRate;
        finalReceived = intReceived / exchangeRate;
      }
    }
    // Case 3: Same currency or paying directly in cart's foreign currency (e.g. THB -> THB)
    else {
      finalTotalPrice = baseTotalPrice;
      finalReceived = intReceived;
      exchangeRateToSend = paymentCurrency?.store_exchange_rate ?? cartCurrency?.exchange_rate ?? 1;
    }

    var total_overdue = 0;
    if (status === "overdue" && finalReceived < finalTotalPrice) {
      total_overdue = finalTotalPrice - finalReceived;
    } else if (status === "overdue" && finalReceived === finalTotalPrice) {
      total_overdue = finalTotalPrice;
      finalReceived = 0;
    } else if (status === "done" && finalReceived === finalTotalPrice) {
      total_overdue = 0;
    } else if (status === "done" && finalReceived > finalTotalPrice) {
      total_overdue = 0;
    }

    const totalDiscount =
      cart && cart.length
        ? cart.map((e) => Number(e.discount) || 0).reduce((a, b) => a + b, 0)
        : 0;

    // get the first txn in cart
    const makeArray = this.salePro(state);
    const discount_type = typeDiscount === "amount" ? "amount" : "percentage";

    const res = {
      data: makeArray,
      total_discount: total_discount + totalDiscount,
      discount_type: discount_type,
      total_price: finalTotalPrice,
      total_overdue: total_overdue,
      total_paid: finalReceived,
      status: status,
      type: type ?? "cash",
      customer_id: customer_id,
      currency_id: paymentCurrency?.id ?? currency?.id ?? null,
      exchange_rate:
        exchangeRateToSend !== null ? exchangeRateToSend.toString() : null,
      txn: cart && cart.length ? cart[0].txn : null,
      note: note,
      price_channel_id:
        state.selectedPriceChannelId || payload.price_channel_id || null,
    };

    // Attach split payment details so backend can persist cash+transfer breakdown
    // into `tickets.payment_data`.
    if (paymentDetails && typeof paymentDetails === "object") {
      res.payment_details = paymentDetails;
      if (type === "cash_transfer") {
        res.cash_amount = parseFloat(paymentDetails.cashAmount) || 0;
        res.transfer_amount = parseFloat(paymentDetails.transferAmount) || 0;
      }
    }

    if (redeem_stamp_reward) {
      res.redeem_stamp_reward = true;
    }

    return res;
  }

  sizeValidate(file) {
    const type = typeof file;
    // if file is not contain http then return true
    if (type === "string" && !file.includes("http")) {
      return true;
    }
    // get image size from env
    const default_size = process.env.VUE_IMG_SIZE || 3; // default 2mb
    // 413 Payload Too Large max size 2mb
    // convert default_size to int
    const size = parseInt(default_size) * 1024 * 1024;
    if (file.size > size) {
      return false;
    } else {
      return true;
    }
  }
  playAudio() {
    const audio = new Audio("/audio/notify.wav");
    audio.play().catch((error) => {
      console.warn("🔊 [Audio] Auto-play blocked:", error.message);
    });
  }
  calTableBill(arr = []) {
    // loop each order in table if status is 'cancel' then skip it, and reduce the total
    const total = arr.reduce((acc, item) => {
      if (item.status !== "cancel") {
        return acc + item.total_price;
      } else {
        return acc;
      }
    }, 0);
    return total;
  }
  async mergeProduct(object) {
    // Check if product_id in history is the same, then merge the qty and total_price
    const result = object.history.reduce((acc, item) => {
      const foundIndex = acc.findIndex(
        (val) => val.product_id === item.product_id
      );
      if (foundIndex !== -1) {
        acc[foundIndex].qty += item.qty;
        acc[foundIndex].total_price += item.total_price;
      } else {
        acc.push(item);
      }
      return acc;
    }, []);
    object.items = result;
    return object;
  }

  reduceProduct({ history }) {
    // Check if product_id.id in history is the same, then merge the qty and total_price
    const result = history.reduce((acc, item) => {
      const foundIndex = acc.findIndex(
        (val) => val.product_id.id === item.product_id.id
      );
      if (foundIndex !== -1) {
        acc[foundIndex].qty += item.qty;
        acc[foundIndex].total_price += item.total_price;
      } else {
        acc.push(item);
      }
      return acc;
    }, []);
    return result;
  }

  paginate(item, next, prev) {
    // Extract all parameters from the first_page_url
    let url = new URL(item.first_page_url);
    let params = new URLSearchParams(url.search);
    // Convert params to an object for easier manipulation
    let paramObject = Object.fromEntries(params.entries());
    paramObject.page = next.page;
    paramObject.per_page = next.itemsPerPage;
    const baseURL = process.env.VUE_APP_BASE_URL;
    // get the http or https from baseURL
    const protocol = baseURL.split(":")[0];
    // Ensure the item.path is HTTPS
    let securePath = item.path.replace(/^http:/, `${protocol}:`);
    // Construct the new URL with all parameters
    let newUrl = new URL(securePath);
    newUrl.search = new URLSearchParams(paramObject).toString();

    return newUrl.toString();
  }

  async generateQuotation(q, cart) {
    const arr = cart.map((val) => ({
      product_id: val.id,
      product_variant_id:
        val.variant_id || (val.variant && val.variant.id) || null,
      quantity: val.qty,
    }));
    return {
      id: q.id ?? null,
      noted: q.note,
      expiry_date: q.expiry_date,
      customer_id: q.customer_id.id,
      include_tax: q.include_tax,
      currency: q.currency,
      document: q.document,
      quotation_details: arr,
    };
  }
}

export default Help = new Help();
